import React from "react";
import {Switch, Redirect, Route} from "react-router-dom";
import Login from "./Login";
import ForgotPassword from "./ForgotPassword";
import TwoFactor from "./TwoFactor";

export const AuthPage = (props) => {
    const {validateTwoFactorCode, isAuthorized} = props;

    return (
        <>
            <div className="d-flex flex-column flex-root">
                {/*begin::Login*/}
                <div
                    className="login login-2 login-signin-on d-flex flex-column flex-lg-row flex-column-fluid bg-primary">
                    {/*begin::Aside*/}
                    <div
                        className="login-aside order-2 order-lg-1 d-flex flex-column-fluid flex-lg-row-auto bgi-size-cover bgi-no-repeat p-7 p-lg-10 bg-white"
                    >
                        {/*begin: Aside Container*/}
                        <div className="d-flex flex-row-fluid flex-column justify-content-between">
                            <div className="d-flex flex-column-fluid flex-column flex-center mt-5 mt-lg-0">
                                <Switch>
                                    <Route path="/auth/login" component={Login}/>
                                    <Route path="/auth/2fa" component={TwoFactor}/>
                                    <Route path="/auth/forgot-password" component={ForgotPassword}/>

                                    {!isAuthorized && validateTwoFactorCode ?
                                        <Redirect from="/auth" exact={true} to="/auth/2fa"/>
                                        : <Redirect from="/auth" exact={true} to="/auth/login"/>
                                    }

                                    {!isAuthorized && validateTwoFactorCode ?
                                        <Redirect to="/auth/2fa"/> : <Redirect to="/auth/login"/>
                                    }
                                </Switch>
                            </div>
                        </div>
                        {/*end: Aside Container*/}
                    </div>
                    {/*begin::Aside*/}

                    {/*begin::Content*/}
                    <div className="order-1 order-lg-2 flex-column-auto flex-lg-row-fluid d-flex flex-column p-7"
                         style={{backgroundImage: 'url(assets/media/bg/bg-4.jpg)'}}>
                        {/*begin::Content body*/}
                        <div className="d-flex flex-column-fluid flex-lg-center">
                            <div className="d-flex flex-column justify-content-center">
                                <h3 className="display-3 font-weight-bold my-7 text-white wow fadeInRight">
                                    Welcome to OptimumDesk!
                                </h3>
                                <p className="font-weight-bold font-size-lg text-white opacity-80 wow zoomIn">
                                    Integrated solution for complete management of your IT support service.
                                    <br/>Everything your IT business needs in only one solution. </p>
                            </div>
                        </div>
                        {/*end::Content body*/}
                    </div>
                    {/*end::Content*/}
                </div>
                {/*end::Login*/}
            </div>
        </>
    );
}
